import { pushDataLayer, getPageType } from '../react/helpers/dataLayer';
import parseDataToProps from '../react/helpers/parseDataToProps';

window.dataLayer = window.dataLayer || [];
const dataLayerNode = document.getElementById('datalayer-data');
const dataLayerFaqNodes = document.getElementsByClassName('accordion__item');
const { pageCategory = '', product, products } = parseDataToProps(dataLayerNode?.dataset || {});

if (getPageType(pageCategory) === 'product' && (product || products)) {
    window.dataLayer.push({
        'event': 'drm',
        'ecomm_prodid': '',
        'ecomm_pagetype': 'category',
        'ecomm_totalvalue': ''
    });
}

if (pageCategory === 'product_detail' && product) {
    pushDataLayer('page', {
        'item_detail': {
            'item_name': product.name,
            'item_categories': product.categories,
        },
    });
} else if (pageCategory === 'product_lister' && products) {
    pushDataLayer('page', {
        'items': products.map((product, productIndex) => {
            return {
                'index': productIndex,
                'item_name': product.name,
                'item_categories': product.categories,
            };
        }),
    });

    window.dataLayer.push({
        'event': 'crto_listingpage',
        'crto': {
            'products': products.map(product => product.code),
        },
    });
} else {
    pushDataLayer('page');
}

if (dataLayerFaqNodes.length > 0) {
    for (let i = 0; i < dataLayerFaqNodes.length; i++) {
        let node = parseDataToProps(dataLayerFaqNodes[i].dataset);
        if (sessionStorage.hasOwnProperty(node.session)) {
            continue;
        }
        dataLayerFaqNodes[i].addEventListener('click', (event) => ((title, text, session) => {
            window.dataLayer.push({
                event : "faq_open",
                interaction_category: title,
                click_text: text
            });
            sessionStorage.setItem(session, title);
        })(node.title, node.text, node.session), {once : true});
    }
}
